import cx from 'classnames';

const getClassNames = (props, ...classNames) => cx(props && props.className, classNames);

export default getClassNames;
